module.exports = __webpack_public_path__ + "1_Goal_Progress_Modal-a6faa707c29cb79a0fdfb4641a8f5161.png";